var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('print-basket-group',{key:`${_vm.index}`,attrs:{"list":_vm.list}})
}
var staticRenderFns = []

export { render, staticRenderFns }